import React from 'react';

const infoIcon = (dreamspace=false) => {
  const color = dreamspace ? "black" : "#10C98F";
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 14.5C11.366 14.5 14.5 11.366 14.5 7.5C14.5 3.63401 11.366 0.5 7.5 0.5C3.63401 0.5 0.5 3.63401 0.5 7.5C0.5 11.366 3.63401 14.5 7.5 14.5Z" fill={color} stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.5 11.25V7.25" stroke="white" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.5 5.5C8.19036 5.5 8.75 4.94036 8.75 4.25C8.75 3.55964 8.19036 3 7.5 3C6.80964 3 6.25 3.55964 6.25 4.25C6.25 4.94036 6.80964 5.5 7.5 5.5Z" fill="white"/>
    </svg>
  );
}
export default infoIcon;
